import { ChangeDetectionStrategy, Component, effect, input, signal, untracked } from '@angular/core';
import { IonImg } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'yt-splash',
  templateUrl: 'splash.html',
  styleUrls: ['splash.scss'],
  imports: [IonImg, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Splash {
  readonly show = input<boolean>(true);

  protected readonly minTimeCompleted = signal<boolean>(false);
  protected readonly show$ = signal<boolean>(true);

  constructor() {
    setTimeout(() => {
      this.minTimeCompleted.set(true);
    }, 5000);
    effect(() => {
      const show = this.show();
      const minTimeCompleted = this.minTimeCompleted();
      untracked(() => {
        if (!show && minTimeCompleted) {
          this.show$.set(false);
        }
      });
    });
  }
}
